<template>
  <div class="modal_wrapper active">
    <div class="modal_window white_box create_report_modal">
      <button
        class="close_modal close_btn"
        @click="closeModal()"
      >
        <svg
          fill="none"
          height="32"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 7L7 25"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            d="M25 25L7 7"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>

      <h3 class="heading_h4 font_bold mb_16">
        {{ widgetModal.widget ? 'Edit' : 'Create' }} Keywords Widget
      </h3>

      <div :class="'section_wrap '+(settings === 'widget' ? 'open' : '')">
        <div
          class="section_head"
          @click="(settings === 'widget' ? settings = '' : settings = 'widget')"
        >
          <h3 class="section_heading">
            Widget Settings
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings === 'widget'"
            class="section_body"
          >
            <custom-input
              v-model="widget.name"
              label="Widget name"
              placeholder="Enter a name for the widget"
              width="full"
            />

            <custom-select
              v-model="widget.attributes.options.metric"
              :options="{
                'average': 'Average Position',
                'top': 'Top Keywords',
                //'custom': 'Custom Select' TODO: Update serpshed to provide better single keyword data
              }"
              :width="widget.attributes.options.metric === 'top' ? 'third' : 'half'"
              label="Metric"
            />

            <custom-select
              v-model="widget.attributes.type"
              :options="widgetTypes"
              :width="widget.attributes.options.metric === 'top' ? 'third' : 'half'"
              label="Widget type"
            />

            <custom-input
              v-if="widget.attributes.options.metric === 'top'"
              v-model="widget.attributes.options.limit"
              label="Limit results to"
              placeholder="All results"
              type="number"
              width="third"
              @changed="value => {widget.attributes.options.limit = value}"
            />

            <custom-select
              v-if="widget.attributes.type.includes('chart')"
              v-model="widget.attributes.options.useDatesFrom"
              :options="{
                'report': 'Report date range',
                'custom': 'Custom date range',
              }"
              label="Use date range"
              width="full"
            />

            <div
              v-if="widget.attributes.options.useDatesFrom === 'custom' && widget.attributes.type.includes('chart')"
              class="custom_daterange"
            >
              <custom-input
                :disabled="true"
                :placeholder="selectedDateRange(widget.attributes.options.dates.fromDate, widget.attributes.options.dates.toDate)"
                :width="widget.attributes.options.dates.compRange ? 'third' : 'half'"
                label="Date range"
              />

              <custom-input
                v-if="widget.attributes.options.dates.compRange"
                :disabled="true"
                :placeholder="selectedDateRange(widget.attributes.options.dates.compFromDate, widget.attributes.options.dates.compToDate)"
                label="Comparison date range"
                width="third"
              />

              <button
                :class="'btn secondary_btn open-datepicker '+(widget.attributes.options.dates.compRange ? 'third' : 'half')"
                @click="datepicker = true"
              >
                <span>Select Date Range</span>
              </button>

              <date-range-picker
                v-if="datepicker"
                v-model:compFromDate="widget.attributes.options.dates.compFromDate"
                v-model:compRange="widget.attributes.options.dates.compRange"
                v-model:compToDate="widget.attributes.options.dates.compToDate"
                v-model:dateRange="widget.attributes.options.dates.dateRange"
                v-model:fromDate="widget.attributes.options.dates.fromDate"
                v-model:toDate="widget.attributes.options.dates.toDate"
                @close="datepicker = false"
              />
            </div>

            <custom-multiselect
              v-show="widget.attributes.options.metric === 'custom'"
              v-model="widget.attributes.options.selectedKeywords"
              :options=" async function(query) {
                //return await fetchTrackedKeywords()
                return {};
              }"
              label="Chosen Keywords"
              mode="tags"
              width="full"
            />

            <custom-multiselect
              v-if="widget.attributes.type.includes('table')"
              v-model="widget.attributes.options.visibleColumns"
              :options="metrics"
              label="Visible Columns"
              mode="tags"
              width="full"
            />
          </div>
        </accordion-transition>
      </div>

      <div
        v-if="widget.attributes.type.includes('chart')"
        :class="'section_wrap '+(settings === 'chart' ? 'open' : '')"
      >
        <div
          class="section_head"
          @click="(settings === 'chart' ? settings = '' : settings = 'chart')"
        >
          <h3 class="section_heading">
            Chart Settings <small>(optional)</small>
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings === 'chart'"
            class="section_body"
          >
            <custom-select
              v-model="widget.attributes.options.useColorsFrom"
              :options="{
                'report' : 'Use Report Colors',
                'custom' : 'Use Custom Colors',
              }"
              label="Chart Colors"
              width="full"
            />

            <custom-color-multiselect
              v-if="widget.attributes.options.useColorsFrom === 'custom'"
              v-model="widget.attributes.chartOptions.colors"
              label="Custom Colors"
              width="full"
            />

            <div
              v-if="widget.attributes.options.dates.compRange"
              class="chart_legend"
            >
              <div class="toggles">
                <custom-toggle
                  v-model="widget.attributes.chartOptions.legend.show"
                  label="Show Legend"
                  width="quarter"
                />
              </div>

              <custom-select
                v-if="widget.attributes.chartOptions.legend.show"
                v-model="widget.attributes.chartOptions.legend.position"
                :options="{
                  'bottom': 'Bottom',
                  'top': 'Top',
                  'right': 'Right',
                  'left': 'Left'
                }"
                label="Legend position"
                width="half"
              />

              <custom-select
                v-if="widget.attributes.chartOptions.legend.show"
                v-model="widget.attributes.chartOptions.legend.horizontalAlign"
                :options="{
                  'center': 'Centre',
                  'right': 'Right',
                  'left': 'Left'
                }"
                label="Legend align"
                width="half"
              />
            </div>

            <div class="toggles">
              <custom-toggle
                v-model="widget.attributes.chartOptions.dataLabels.enabled"
                label="Show Data Labels"
                width="quarter"
              />

              <custom-toggle
                v-model="widget.attributes.chartOptions.grid.xaxis.lines.show"
                label="Show X Axis Grid"
                width="quarter"
              />

              <custom-toggle
                v-model="widget.attributes.chartOptions.grid.yaxis.lines.show"
                label="Show Y Axis Grid"
                width="quarter"
              />
            </div>
          </div>
        </accordion-transition>
      </div>

      <div
        v-if="widget.attributes.type === 'table'"
        :class="'section_wrap '+(settings === 'filter' ? 'open' : '')"
      >
        <div
          class="section_head"
          @click="(settings === 'filter' ? settings = '' : settings = 'filter')"
        >
          <h3 class="section_heading">
            Filter Settings
            <small>(optional)</small>
          </h3>
          <small
            v-if="widget.attributes.options.filters.length > 0"
            class="filters_applied"
          >
            ({{ widget.attributes.options.filters.length }} Filters Applied)
          </small>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings === 'filter'"
            class="section_body"
          >
            <div class="existing_filters">
              <h4>Existing Filters:</h4>
              <div class="filter_tags">
                <div
                  v-for="(filter, index) in widget.attributes.options.filters"
                  :key="index"
                >
                  <span>
                    Where "{{ metrics[filter.metric] }}"
                    {{ expressions[filter.expression] }}
                    "{{ filter.value }}"
                  </span>
                  <button
                    class="delete_filter delete_btn"
                    @click="removeFilter(index)"
                  >
                    <svg-vue icon="icons/cross" />
                  </button>
                </div>
              </div>
            </div>

            <custom-select
              v-model="newFilter.metric"
              :options="metrics"
              placeholder="Select metric"
              label="New filter"
              width="third"
              :validation-errors="filterErrors.metric"
            />
            <custom-select
              v-model="newFilter.expression"
              :options="expressions"
              placeholder="Select expression"
              label="&nbsp;"
              width="third"
              :validation-errors="filterErrors.expression"
            />
            <custom-input
              v-model="newFilter.value"
              placeholder="Enter a value for the filter"
              label="&nbsp;"
              width="third"
              :validation-errors="filterErrors.value"
            />
            <primary-button
              size="sm"
              class="add_filter"
              @click="addFilter"
            >
              Add filter
            </primary-button>
          </div>
        </accordion-transition>
      </div>

      <div
        v-if="widget.attributes.type === 'table'"
        :class="'section_wrap '+(settings === 'table' ? 'open' : '')"
      >
        <div
          class="section_head"
          @click="(settings === 'table' ? settings = '' : settings = 'table')"
        >
          <h3 class="section_heading">
            Table Settings <small>(optional)</small>
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings === 'table'"
            class="section_body"
          >
            <custom-select
              v-model="widget.attributes.tableOptions.align"
              :options="{
                'center' : 'Center',
                'start' : 'Left',
                'end' : 'Right'
              }"
              label="Text Align"
              width="full"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.headerColor"
              label="Header color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.headerTextColor"
              label="Header text color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.primaryRowColor"
              label="Primary row color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.primaryRowTextColor"
              label="Primary row text color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.secondaryRowColor"
              label="Secondary row color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.secondaryRowTextColor"
              label="Secondary row text color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />
          </div>
        </accordion-transition>
      </div>

      <div class="flex items-center section_modal_footer">
        <button
          class="btn btn_md secondary_btn close_modal ml_auto mr_8"
          @click="closeModal()"
        >
          <span>Cancel</span>
        </button>
        <button
          class="btn btn_md primary_btn"
          @click="save()"
        >
          <span>{{ widgetModal.widget ? 'Update' : 'Create' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import axios from 'axios';
import CustomInput from '../../global/forms/CustomInput.vue';
import CustomSelect from '../../global/forms/CustomSelect.vue';
import CustomColorSelect from '../../global/forms/CustomColorSelect.vue';
import CustomColorMultiselect from '../../global/forms/CustomColorMultiselect.vue';
import CustomMultiselect from '../../global/forms/CustomMultiselect.vue';
import CustomToggle from '../../global/forms/CustomToggle.vue';
import DateRangePicker from '../../global/forms/DateRangePicker.vue';
import AccordionTransition from '../../global/transitions/AccordionTransition.vue';
import PrimaryButton from "../../../../../js/components/global/buttons/PrimaryButton";

export default {
  components: {
    PrimaryButton,
    CustomInput,
    CustomSelect,
    CustomColorSelect,
    CustomMultiselect,
    CustomColorMultiselect,
    CustomToggle,
    DateRangePicker,
    AccordionTransition
  },
  emits: ['refresh-widget'],
  data() {
    return {
      datepicker: false,
      settings: 'widget',
      widgetTypes: {
        'line-chart': 'Line chart',
        'area-chart': 'Area chart'
      },
      widget: {
        id: `widget-keywords-${Date.now()}`,
        name: 'Keywords Widget',
        type: 'keywords',
        w: 6,
        h: 25,
        frozen: false,
        content: `<div id="widget-keywords-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
        attributes: {
          type: 'line-chart',
          options: {
            metric: 'average',
            keywords: [],
            limit: null,
            useDatesFrom: 'report',
            useColorsFrom: 'report',
            dates: {
              dateRange: null,
              compRange: null,
              fromDate: '',
              toDate: '',
              compFromDate: '',
              compToDate: ''
            },
            visibleColumns: ['keyword', 'ranking_url', 'current_position', 'previous_day', 'previous_week', 'previous_month', 'search_volume'],
            selectedKeywords: [],
            filters: [],
          },
          tableOptions: {
            align: 'center',
            headerColor: '#F5F5F5',
            headerTextColor: '#4E4E54',
            primaryRowColor: '#FFFFFF',
            primaryRowTextColor: '#4E4E54',
            secondaryRowColor: '#F8F7F5',
            secondaryRowTextColor: '#4E4E54',
          },
          chartOptions: {
            chart: {
              id: `widget-keywords-${Date.now()}`,
              animations: {
                enabled: false
              }
            },
            title: {
              text: '',
              align: 'center'
            },
            colors: [],
            grid: {
              xaxis: {
                lines: {
                  show: false
                }
              },
              yaxis: {
                lines: {
                  show: false
                }
              },
            },
            legend: {
              show: false,
              position: 'bottom',
              horizontalAlign: 'center',
            },
            dataLabels: {
              enabled: false
            },
            yaxis: {
              reversed: true
            }
          }
        }
      },
      metrics: {
        keyword: 'Keyword',
        ranking_url: 'Page',
        current_position: 'Current position',
        previous_day: 'Previous Day',
        previous_month: 'Previous Month',
        previous_week: 'Previous Week',
        search_volume: 'Search Volume',
        first_position: 'First Position',
        first_date: 'First Tracked Date',
      },
      newFilter: {
        metric: null,
        expression: null,
        value: null,
      },
      expressions: {
        '==' : 'is equal to',
        '!=': 'is not equal to',
        'contains' : 'contains',
        'doesNotContain' : 'does not contain',
        '>=': 'is greater than or equal to',
        '<=': 'is less than or equal to',
      },
      filterErrors: {
        metric: [],
        expression: [],
        value: [],
      }
    }
  },
  computed: {
    ...mapState('report', ['report']),
    ...mapState(['widgetModal']),
  },
  watch: {
    'widget.attributes.options.metric': {
      handler(a, b) {
        if (a !== b) {
          if (this.widget.attributes.options.metric === 'average') {
            this.widget.attributes.type = 'line-chart';
            this.widgetTypes = {
              'line-chart': 'Line chart',
              'area-chart': 'Area chart'
            }
          }

          if (this.widget.attributes.options.metric === 'top') {
            this.widget.attributes.type = 'table';
            this.widgetTypes = {
              'table': 'Table'
            }
          }
        }

      }
    },
    'widget.attributes.options.useDatesFrom': {
      handler(a) {
        if (a === 'report') {
          this.updateToReportDates();
        }
      }
    },
  },
  beforeMount() {
    if (this.widgetModal.widget) {
      _.merge(this.widget, this.widgetModal.widget);
      this.widget.attributes.options.visibleColumns = this.widgetModal.widget.attributes.options.visibleColumns;
    }
  },
  mounted() {
    this.updateToReportDates();
  },
  methods: {
    ...mapActions('pages', ['addWidget', 'updateWidget']),
    ...mapActions('widgetModal', ['closeModal']),
    async fetchTrackedKeywords() {
      const {data} = await axios.get('/ajax/reports/widgets/tracked-keywords');
      return data;
    },
    updateToReportDates() {
      if (this.widget.attributes.options.useDatesFrom === 'report') {
        this.widget.attributes.options.dates.dateRange = this.report.date_range;
        this.widget.attributes.options.dates.compRange = this.report.comp_range;
        this.widget.attributes.options.dates.fromDate = this.report.from_date;
        this.widget.attributes.options.dates.toDate = this.report.to_date;
        this.widget.attributes.options.dates.compFromDate = this.report.comp_from_date;
        this.widget.attributes.options.dates.compToDate = this.report.comp_to_date;
      }
    },
    selectedDateRange(fromDate, toDate) {
      if (fromDate && toDate) {
        let from = moment(fromDate, 'YYYY-MM-DD').format(this.report.date_format);
        let to = moment(toDate, 'YYYY-MM-DD').format(this.report.date_format);
        return from + ' - ' + to;
      }
      return 'Please select dates';
    },
    async save() {
      if (!this.widget.resized && !this.widgetModal.widget) {
        if (this.widget.attributes.type.includes('table') || this.widget.attributes.type.includes('stat-boxes')) this.widget.w = 12;
      }

      // Prep a payload for the vuex action
      const payload = {
        widget: this.widget,
        pageId: this.widgetModal.pageId,
      }

      // Check if we're creating a new widget or editing one
      if (!this.widgetModal.widget) {
        // Save the new pages layout (refreshes store pages)
        await this.addWidget(payload);
      } else {
        // Update the widget
        payload.widget.resized = false;
        await this.updateWidget(payload);
      }

      // Emit to trigger widget refresh, then close the modal
      this.$emit('refresh-widget', {pageId: this.widgetModal.pageId, widget: this.widget});
      this.closeModal();
    },
    addFilter() {
      if (this.checkFilterErrors().length > 0) {
        return;
      }

      this.widget.attributes.options.filters.push(this.newFilter);
      this.newFilter = {
        metric: [],
        expression: [],
        value: null,
      }
    },
    removeFilter(index) {
      this.widget.attributes.options.filters = this.widget.attributes.options.filters.filter((filter, filterIndex) => {
        return filterIndex !== index;
      });
    },
    checkFilterErrors() {
      this.filterErrors = {
        metric: this.newFilter.metric ? [] : ['Please select a metric'],
        expression: this.newFilter.expression ? [] : ['Please select a expression'],
        value: this.newFilter.value ? [] : ['Please enter a value'],
      }

      return _.filter(this.filterErrors, function (error) {
        return error.length > 0;
      })
    }
  },
}
</script>

<style scoped src="../../../../reports/css/modal.css" />

<style scoped>
.existing_filters {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.filter_tags {
  display: flex;
  gap: 0.5rem;
  padding-left: 0.5rem;
  flex-wrap: wrap;
  max-height: 10.625rem;
  overflow-y: auto;
}

.filter_tags div {
  display: flex;
  align-items: center;
  gap: .25rem;
  background: var(--primary-color);
  border-radius: 4px;
  color: white;
  font-size: .75rem;
  font-weight: 400;
  line-height: 1.25rem;
  margin-bottom: .25rem;
  padding: .125rem 0 .125rem .5rem;
  white-space: nowrap;
}

.existing_filters h4 {
  margin-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
  font-weight: 700;
  padding: .438rem .625rem;
}

.delete_filter {
  width: 20px;
  display: flex;
  padding: 0;
  margin: 0;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.delete_filter:hover {
  background: var(--primary-color-dark);
}

.delete_filter svg {
  height: 12px;
  width: 12px;
}

:deep(.delete_filter svg) path {
  stroke: white;
}

.add_filter {
  margin-top: -1rem;
}

.filters_applied {
  color: var(--primary-color);
  margin-left: auto;
  margin-right: .5rem;
}
</style>
